import { render, staticRenderFns } from "./RequestJoinChatV2.vue?vue&type=template&id=709fe32e&scoped=true"
import script from "./RequestJoinChatV2.vue?vue&type=script&lang=js"
export * from "./RequestJoinChatV2.vue?vue&type=script&lang=js"
import style0 from "./RequestJoinChatV2.vue?vue&type=style&index=0&id=709fe32e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "709fe32e",
  null
  
)

export default component.exports